import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { FormattedDate } from 'react-intl';
import displayName from '../../../../helpers/displayName';
import { Box, Button, ButtonBar } from '../../../../common/components';
import { hasPermission } from '../../../auth/redux/authActions';
import getIncludedResource from '../../../../helpers/getIncludedResource';
import { isBoolean } from 'lodash';
import { Grid, Row, Col, ControlLabel } from 'react-bootstrap';
import './styles.scss';

const Section = ({ section, resource, sectionKey }) => {
  if (sectionKey.indexOf('date') !== -1) {
    return <FormattedDate value={new Date(section)} />;
  }
  if (sectionKey === 'hero') {
    if (!section) {
      return null;
    }

    const files = getIncludedResource(resource.data, resource.included, 'files');
    let hero = null;

    files.forEach((file) => {
      if (file.id === section) {
        hero = file;
      }
    });

    return <img src={hero.attributes.url} alt="hero" />;
  }

  if (sectionKey === 'questions') {
    return (
      <div>
        <div className="content-show-section">
          {section.map((questionSection) => {
            const questions = questionSection.questions_and_answers;
            return questions.map((question) => (
              <div key={question.question}>
                <div className="RichEditor-root">
                  <ReactMarkdown source={question.question} />
                  <ReactMarkdown source={question.answer} />
                </div>
              </div>
            ));
          })}
        </div>
      </div>
    );
  }
  if (Array.isArray(sectionKey)) {
    return section.map((field, key) => {
      if (field == null) {
        return null;
      }
      return (
        <div key={key} className="content-show-section">
          <div className="RichEditor-root">
            <ReactMarkdown source={field.question} heading />
            <ReactMarkdown source={field.answer} />
          </div>
        </div>
      );
    });
  }

  if (sectionKey === 'attachments') {
    return (
      <div className="content-show-section">
        <div className="RichEditor-root">
          {Object.keys(section).map((key) => {
            return (
              <a href={section[key].url} target={'_blank'}>
                <ReactMarkdown source={section[key].name} />
              </a>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div className="content-show-section">
      <div className="RichEditor-root">
        <ReactMarkdown source={section} />
      </div>
    </div>
  );
};

export default class ContentShow extends Component {
  static propTypes = {
    resource: PropTypes.object.isRequired,
  };

  render() {
    const resource = this.props.resource.data.attributes;
    const sections = resource.sections;
    return (
      <Box>
        <Grid fluid>
          <Row>
            <Col sm={12}>
              <h2>{resource.name}</h2>
            </Col>
          </Row>

          {Object.keys(sections).map((section) => {
            if (Array.isArray(sections[section])) {
              return (
                <Row key={section}>
                  <Col sm={2}>
                    <label>{displayName(section)}</label>
                  </Col>
                  <Col sm={10}>
                    <Section
                      section={sections[section]}
                      sectionKey={section}
                      resouce={this.props.resource}
                    />
                  </Col>
                </Row>
              );
            } else if (isBoolean(sections[section])) {
              return '';
            }
            return (
              <Row key={section}>
                <Col sm={2}>
                  <ControlLabel>{displayName(section)}</ControlLabel>
                </Col>
                <Col sm={10}>
                  <Section
                    section={sections[section]}
                    sectionKey={section}
                    resouce={this.props.resource}
                  />
                </Col>
              </Row>
            );
          })}

          <ButtonBar>
            {hasPermission('content_management.edit') && (
              <Button
                link={true}
                to={'/admin/content/' + this.props.resource.data.id + '/edit'}
                className="pull-right"
                bsStyle="primary"
                rightIcon="pencil-square-o"
                label="edit content"
              />
            )}
          </ButtonBar>
        </Grid>
      </Box>
    );
  }
}
